<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h5 class="label-black" style="margin-bottom: 0px;">DOCUMENTOS</h5>
            <h6 class="label-black" style="margin-top: 0px;">Definición de las Sedes de Resguardo del Archivo Judicial</h6>
        </div>

        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area custom-area">
                    <div class="form-group" id="Busqueda_div">
                        <label class="label-black">Área</label>
                        <CAreas
                        v-on:valorParaElPadre="cambioDeArea" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="'filtroDeBusqueda_Area'" 
                        :parametros="parametros_Area" 
                        :valorDefinido="parametros_Area.areaId" 
                        :key="parametros_Area.areaId"
                        >
                        </CAreas>
                    </div>
                    <div id="BotonBusqueda_div" class="text-right">
                        <button class="btn btn-sm btn-custom"  @click='ObtenerDefinicion()'>Ver Deficiniones</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area custom-area">
                    <div id="Sedes_table" class="table-responsive">
                        <table class="table table-striped table-light table-hover table-sm">
                            <thead class="thead-custom">
                                <tr>
                                <th>Área</th>
                                <th>Año Documento Inicial</th>
                                <th>Año Documento Final</th>
                                <th>Sede de Archivo</th>
                                <th></th>
                                <th></th>
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                                <tr v-if="DefinicionSedesArchivo.length <= 0">
                                    <td colspan="12" class="text-center">Seleccione un Área para Obtener resultados</td>
                                </tr>
                                <tr v-else v-for="definiciones in DefinicionSedesArchivo" :key="definiciones.DefinicionSedeArchivoId">
                                    <td>{{definiciones.Area.Nombre}}</td>
                                    <td class="text-center">{{definiciones.AnioInicio}}</td>
                                    <td class="text-center">{{definiciones.AnioFinal}}</td>
                                    <td>{{definiciones.SedeArchivo.Nombre}}</td>
                                    <td class="text-center">
                                        <a v-on:click="EditarDefinicion(definiciones.DefinicionSedeArchivoId)" title="Editar Definición">
                                        <i class="fas fa-pen-square"></i>
                                        </a>
                                    </td>
                                    <td class="text-center">
                                        <a v-on:click="EliminarDefinicion(definiciones.DefinicionSedeArchivoId)" title="Eliminar Definición">
                                        <i class="fas fa-minus-circle"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-right" v-if="this.MostrarBoton ==true">
                        <button class="btn btn-custom btn-sm" @click="NuevaDefinicion()">Agregar Nueva Definición</button>
                    </div>

                </div>
            </div>
        </div>
        <div v-if="this.modalDefiniciones == true">
            <EditModal :definicionSedeId= this.parametro_DefinicionArchivoId :DefinicionArea= this.parametro_DefinicionArea :ListaDefiniciones= this.DefinicionSedesArchivo @dialogo='EstatusModal($event)'></EditModal>
        </div>
    </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import modal from '@/components/ArchivoJudicial/Comun/AddEditDefinicion.vue'

export default {
    components:{
      CAreas : catalogos.ArchivoJudicial.C001Areas,
      EditModal : modal
    },
    data(){
        return{
            enumeraciones,
            parametros_Area: {
                areaId: -1,
                conMaterias: true
            },
            DefinicionSedesArchivo: [],
            modalDefiniciones: false,
            parametro_DefinicionArchivoId: 0,
            parametro_DefinicionArea: {
                AreaId: 0,
                Nombre: ""
            },
            MostrarBoton : false
        }
    },
    methods:{
        cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
            
            this.parametro_DefinicionArea.AreaId = parseInt(datos[0].target.value);
            this.parametro_DefinicionArea.Nombre = datos[0].target.selectedOptions[0].text;
        },
        ObtenerDefinicion(){
            if(this.ValidaDatosBuqueda()){
                var peticion = {
                    "AreaId": this.parametros_Area.areaId
                };
               
                this.MostrarBoton = true;
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.ListaDefinicionSedes, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then(respuesta => {
                    if (respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        comun.SeEstaCargandoInformacion(false);
                    }
                    else
                    {
                        this.DefinicionSedesArchivo = respuesta.data.GetListaDefinicionSedes;
                        
                        comun.SeEstaCargandoInformacion(false);
                    }
                    comun.SeEstaCargandoInformacion(false);
                    
                })
                .catch(e=> {
                    console.log("No Hay Respuesta del Servidor", e);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }
        },
        ValidaDatosBuqueda(){
            if(this.parametros_Area == null || this.parametros_Area.areaId == -1)
                    { comun.mensajeDeAlerta("Seleccionar una área", null, null);
            return false;}
            return true
        },
         EstatusModal(valor){
            this.modalDefiniciones = valor;
            if(this.modalDefiniciones == false)
            {
                this.ObtenerDefinicion();
            }
        },
        EditarDefinicion(id){
            this.parametro_DefinicionArchivoId = id;
            this.modalDefiniciones = true;
        },
        NuevaDefinicion(){
            
            this.parametro_DefinicionArchivoId = null;
            this.modalDefiniciones = true;
        },
        EliminarDefinicion(datos){
            
            let peticion = {"DefinicionSedeArchivoId": datos}
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.EliminarDefinicion, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then(respuesta => {
                if (respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    comun.SeEstaCargandoInformacion(false);
                }
                else
                {
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    comun.SeEstaCargandoInformacion(false);
                    this.ObtenerDefinicion();
                }
                comun.SeEstaCargandoInformacion(false);
            })
            .catch(e=> {
                console.log("No Hay Respuesta del Servidor", e);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
        }
    }
}
</script>
<style scoped>
    .thead-custom {
    background-color: #004746;
    color: white;
    }
    .custom-area {
    background-color: #7e7f74;
    }
    .label-black {
    color: black;
    }
    .btn-custom {
    background-color: #004746;
    color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Inventario/DefinicionSedes.vue